export default "__VITE_ASSET__02dtmmVg__"